type ColorBoxProps = {
  color: string;
};

export const ColorBox: React.FC<ColorBoxProps> = ({ color }) => (
  <div
    style={{
      background: color,
      minHeight: '0.8rem',
      minWidth: '0.8rem',
      borderRadius: '4px',
    }}
  />
);
